import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Loader, TextTooltip } from "@transfr-inc/dashboard-components";
import { Button } from "@transfr-inc/dashboard-components/forms";

import { copyToClipboard } from "@lib/browser-utils";
import { minutesToDays } from "@lib/date.utils";
import { useApiRequest } from "@lib/hooks";
import container from "@src/container";

import "./classroom.qr.tab.scss";

const infoText = "Copied to clipboard";

export const ClassroomQRTab = ({ classroom }) => {
  const { classroomId } = classroom ?? {};
  const { classroomService } = container;

  const { loading, response } = useApiRequest(() =>
    classroomService.getQuickSignupQRCode(classroomId).then((response) => {
      return {
        imgString: `data:image/png;base64,${response?.code}`,
        link: response?.link,
        ttlFormatted: minutesToDays(response?.ttlMinutes),
      };
    })
  );

  return (
    <div className="classroom-qr-main-container">
      {loading ? (
        <div className="loading-container">
          <Loader />
          <span>Generating QR code...</span>
        </div>
      ) : (
        <>
          <div className="qr-signup-text">
            Quickly signup students for this classroom.{" "}
            <TextTooltip
              className="tooltip"
              text={`Link and QR code expire in ${response?.ttlFormatted}, please refresh to generate a new code.`}
            >
              <FontAwesomeIcon icon="fa-regular fa-circle-info" />
            </TextTooltip>
          </div>
          <img className="qr-img" src={response?.imgString} />
          <TextTooltip className="info" text={infoText} trigger="click">
            <Button
              icon={["fa-light", "fa-link"]}
              onClick={() => copyToClipboard(response?.link)}
              size="small"
            >
              Copy Link
            </Button>
          </TextTooltip>
        </>
      )}
    </div>
  );
};
